export const MAP_MOVE_END = '@mapCore/MOVE_END';
export const MAP_CLICK = '@mapCore/CLICK';
export const SET_LAYER_IS_READY = '@mapCore/SET_LAYER_IS_READY';
export const INTERACTION_SELECT_FEATURES = '@mapCore/INTERACTION_SELECT_FEATURES';
export const INTERACTION_DRAW_FEATURES = '@mapCore/INTERACTION_DRAW_FEATURES';
export const DELETE_FEATURES = '@mapCore/DELETE_FEATURES';
export const DELETE_ALL_FEATURES = '@mapCore/DELETE_ALL_FEATURES';
export const INTERACTION_MODIFY_FEATURES = '@mapCore/INTERACTION_MODIFY_FEATURES';
export const INVALIDATE_VECTOR_TILE_LAYER = '@mapCore/INVALIDATE_VECTOR_TILE_LAYER';
export const SET_MAP_DEFAULT_STATE = '@mapCore/SET_MAP_DEFAULT_STATE';
export const SET_MAP_STATE = '@mapCore/SET_MAP_STATE';
export const SET_MAP_ZOOM = '@mapCore/SET_MAP_ZOOM';
export const ADD_MAP_ZOOM = '@mapCore/ADD_MAP_ZOOM';
export const SET_MAP_CENTER = '@mapCore/SET_MAP_CENTER';
export const SET_MAP_EXTENT = '@mapCore/SET_MAP_EXTENT';
export const SET_MAP_ROTATION = '@mapCore/SET_MAP_ROTATION';
export const SET_LAYER_VISIBILITY = '@mapCore/SET_LAYER_VISIBILITY';
export const SET_LAYER_OPACITY = '@mapCore/SET_LAYER_OPACITY';
export const SET_LAYER_FEATURE_HIGHLIGHT = '@mapCore/SET_LAYER_FEATURE_HIGHLIGHT';
export const SET_LAYER_FEATURES = '@mapCore/SET_LAYER_FEATURES';
export const SET_LAYER_STYLE = '@mapCore/SET_LAYER_STYLE';
export const SET_LAYER_MAPBOX_STYLE = '@mapCore/SET_LAYER_MAPBOX_STYLE';
export const ADD_VECTOR_TILE_HIDDEN_FEATURES = '@mapCore/ADD_VECTOR_TILE_HIDDEN_FEATURES';
export const SET_VECTOR_TILE_HIDDEN_FEATURES = '@mapCore/SET_VECTOR_TILE_HIDDEN_FEATURES';
export const UPDATE_LAYERS = '@mapCore/UPDATE_LAYERS';
export const SET_INTERACTION = '@mapCore/SET_INTERACTION';
export const MERGE_LAYERS = '@mapCore/MERGE_LAYERS';
export const SET_SNAP_INTERACTION = '@mapcore/SET_SNAP_INTERACTION';
export const ADD_LAYERS = '@mapCore/ADD_LAYERS';
export const SET_MAPBOX_FEATURE_STATE = '@mapCore/SET_MAPBOX_FEATURE_STATE';
export const ANIMATION_DURATON = {
    ZOOM: 350,
};
//# sourceMappingURL=constants.js.map